import { TranslateService } from '@ngx-translate/core';
import { AllInputTypes, FormInputConfig, ListValues } from '../../../../../trash/shared/interfaces/form-input-config';
import { getIdFormConfig } from '../../../../../views/pages/adminstration/temp-common/utils';
import { IUserResponse } from '../../../system-management';
import { IUpdateUserRequest } from '../dtos';
import { Validators } from '@angular/forms';

export class UpdateAccountUserModel implements IUpdateUserRequest {
  id?: string;
  firstName: string;
  lastName: string;

  private constructor(request: IUpdateUserRequest) {
    this.id = request.id;
    this.firstName = request.firstName;
    this.lastName = request.lastName;
  }

  static create(request: IUpdateUserRequest): UpdateAccountUserModel {
    return new UpdateAccountUserModel(request);
  }

  static createDefault(): UpdateAccountUserModel {
    return UpdateAccountUserModel.create({
      id: '',
      firstName: '',
      lastName: ''
    });
  }

  static createFromItem(item: IUserResponse): UpdateAccountUserModel {
    return new UpdateAccountUserModel({
      id: item.id,
      firstName: item.firstName,
      lastName: item.lastName
    });
  }

  getFormConfig(roles: ListValues[], isVisible?: boolean, translate?: TranslateService): FormInputConfig[] {
    return [
      getIdFormConfig(this.id),
      {
        type: AllInputTypes.Text,
        name: 'firstName',
        label: translate?.instant('FORMS.FIRST_NAME'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('FORMS.FIRST_NAME')}`,
        defaultValue: this.firstName,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [{ function: Validators.required, errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('FORMS.FIRST_NAME')}` }]
      },
      {
        type: AllInputTypes.Text,
        name: 'lastName',
        label: translate?.instant('FORMS.LAST_NAME'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('FORMS.LAST_NAME')}`,
        defaultValue: this.lastName,
        isDisable: !isVisible,
        widthClass: 'col-12',
        validation: [{ function: Validators.required, errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('FORMS.LAST_NAME')}` }]
      },
    ];
  }
}
